import _ from 'lodash'

class AddNewController {
  constructor(LanguageFactory, growl, Information, Util) {
    "ngInject";

    let vm = this;
    vm.newItem = null;
    vm.language = "IT";
    vm.summernoteOptions = Util.getSummernoteOptions();

    vm.saveNewItem = saveNewItem;

    init();

    function init() {
      vm.newItem = {
        information: {
          active: true
        },
        informationStringsList: []
      }

      _.each(LanguageFactory.getAvailableLanguageKeys(), l => {
        vm.newItem.informationStringsList.push({
          title: "",
          body: "",
          language: l
        })
      });
    }

    function saveNewItem(itemToSave) {
      Information.post(itemToSave).then(res => {
        growl.success("Sezione aggiunta con successo");
        vm.close();
      }, err => {
        growl.error("Errore salvataggio sezione");
      })
    }


  }
}

export default AddNewController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/addNew/addNew.controller.js